import React from "react";
import styled from "styled-components";
import NEAPLogo from "../../assets/neat/neap_logo.svg";
import DesktopDeivceLogo from "../../assets/neat/desktop_deivce.svg";

const Wrapper = styled.div`
  width: 100vw;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f3f6ff;
  @media screen and (max-width: 1240px) {
    height: 100vh;
    height: 100svh;
  }
`;
const Container = styled.div`
  width: 80%;
  border-radius: 20px;
  background: #fff;
  box-shadow: 0px 16px 32px 0px rgba(221, 230, 237, 0.4);
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 48px 0 80px 0;
  justify-content: center;
  gap: 97px;

  @media screen and (max-width: 1240px) {
    width: 100%;
    margin: 0 16px;
    padding: 40px 16px;
  }
`;

const ContentSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 16px;

  img {
    width: 256px;
    @media screen and (max-width: 1240px) {
      width: 130px;
    }
  }
`;

const Header = styled.h6`
  color: #242424;
  text-align: center;
  font-family: Poppins;
  font-size: 36px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  @media screen and (max-width: 1240px) {
    font-size: 24px;
  }
`;

const Content = styled.p`
  color: #464646;
  text-align: center;
  font-family: Poppins;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  @media screen and (max-width: 1240px) {
    font-size: 14px;
  }
`;

function DeviceNotSupport({
  logo = NEAPLogo,
  icon = DesktopDeivceLogo,
  // title = "Heads up!",
  title = "SOMETHING WENT WRONG",
  // description = "Please switch to a desktop device to continue.",
  description = "Please try again later.",
  children,
}) {
  return (
    <Wrapper>
      <Container>
        {logo && <img src={logo} alt="" style={{ width: "234px" }} />}
        <ContentSection>
          <img src={icon} alt="" />
          <Header>{title}</Header>
          <Content>{description}</Content>

          {children}
        </ContentSection>
      </Container>
    </Wrapper>
  );
}

export default DeviceNotSupport;
